import { Product } from '@interfaces';

const availabilityNumberTransform = {
  AVAILABLE_24_HRS: 0,
  AVAILABLE: 1,
  REPRESENTATION: 2,
  TO_CONFIRM: 3,
};
export const sortedRelatedProducts = (
  relatedProducts: Product[],
  productUUID: string,
): Product[] => {
  return (
    relatedProducts
      ?.filter((relatedProduct) =>
        Object.keys(availabilityNumberTransform).includes(
          relatedProduct.availability?.status,
        ),
      )
      .filter((relatedProduct) => productUUID !== relatedProduct?.uuid)
      .slice(0, 10) ?? []
  );
};
